import * as React from "react";
import { Pagination, PaginationProps } from "react-admin";

const MyPagination: React.FC<PaginationProps> = (props) => {
  return <Pagination {...props} />;
};

export default MyPagination;
